import { render } from "./AssessmentMark.vue?vue&type=template&id=0aadb627&scoped=true"
import script from "./AssessmentMark.vue?vue&type=script&lang=js"
export * from "./AssessmentMark.vue?vue&type=script&lang=js"

import "./AssessmentMark.vue?vue&type=style&index=0&id=0aadb627&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aadb627"]])

export default __exports__